import { useQueryClient } from '@tanstack/vue-query'
import { useSessionStorage } from '@vueuse/core'

const CLEAR_CACHE_ERROR_KEY = 'clear_cache_error_count'
const MAX_CLEAR_CACHE_ERRORS = 3

/**
 * Composable to clear all application cache including localStorage, sessionStorage, and query cache
 */
export function useClearCache() {
  const queryClient = useQueryClient()
  const errorCount = useSessionStorage<number>(CLEAR_CACHE_ERROR_KEY, 0)

  function clearCache() {
    try {
      // Check error count to prevent infinite loops
      if (errorCount.value >= MAX_CLEAR_CACHE_ERRORS) {
        console.error('Max clear cache errors reached. Stopping to prevent infinite loop.')
        return
      }

      // Clear all localStorage
      localStorage.clear()

      // Clear all sessionStorage
      sessionStorage.clear()

      // Clear all query cache
      queryClient.clear()

      // Reload the page to ensure a fresh start
      window.location.reload()
    }
    catch (error) {
      console.error('Error clearing cache:', error)

      // Increment error count
      errorCount.value += 1

      // Still try to reload if we haven't hit the max
      if (errorCount.value < MAX_CLEAR_CACHE_ERRORS) {
        window.location.reload()
      }
    }
  }

  return {
    clearCache,
  }
}
